/* HC GST is a browsing display preference, never a cart/checkout price mutation. */
(() => {
  const root = document.documentElement;
  const enabled = root.dataset.hcGstEnabled === 'true';
  window.FoxTheme = window.FoxTheme || {};
  const pair = (inclusive, exclusive) => '<span class="hc-gst-inc">' + inclusive + '</span><span class="hc-gst-ex">' + exclusive + '</span>';
  FoxTheme.GST = {
    enabled,
    money(cents, taxable, format) {
      const inclusive = FoxTheme.Currency.formatMoney(cents, format);
      if (!enabled || taxable !== true) return inclusive;
      return pair(inclusive, FoxTheme.Currency.formatMoney(Math.round(Number(cents) / 1.1), format));
    },
    note(taxable) {
      if (!enabled) return '';
      if (taxable === false) return 'GST-free';
      if (taxable !== true) return '';
      return pair('incl. GST', 'excl. GST');
    }
  };
  if (!enabled) return;
  function sync() {
    const mode = root.dataset.hcGstMode === 'ex' ? 'ex' : 'inc';
    document.querySelectorAll('[data-hc-gst-choice]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.hcGstChoice === mode));
    });
    document.querySelectorAll('.hc-gst-control').forEach(control => { control.hidden = false; });
  }
  function choose(mode) {
    root.dataset.hcGstMode = mode === 'ex' ? 'ex' : 'inc';
    try { localStorage.setItem('gstToggle', String(mode !== 'ex')); } catch (error) { /* Session-only preference is still usable. */ }
    sync();
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-hc-gst-choice]');
    if (button) choose(button.dataset.hcGstChoice);
  });
  window.addEventListener('storage', event => {
    if (event.key === 'gstToggle' || event.key === null) {
      root.dataset.hcGstMode = event.newValue === 'false' ? 'ex' : 'inc';
      sync();
    }
  });
  document.addEventListener('shopify:section:load', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, {once:true});
  else sync();
})();
